module.exports = __webpack_public_path__ + "img/11825380_S.7e9c2d42.png";